module.exports = __webpack_public_path__ + "static/media/logo-square.4a49f24a.png";